<template>
  <div id="login" lang="en">
    <!-- TITLE//S-->
    <div class="page-header">
      <h3>Identity verification</h3>
    </div>
    <!-- TITLE//E-->
    <!-- TITLE//E-->
    <div class="login-info-text"></div>
    <!-- LOGIN FORM//S -->
    <div class="well login-wrap otp-register full-popup">
      <div>Please upload your picture for following requirement.</div>
      <div class="help">※ Less than 10MB / Attach JPG image file only</div>

      <ul class="ul" style="padding-bottom: 30px;">
        <!-- 신분증 사진 -->
        <li class="li">
          <p>
            1. Photographed ID card (Certificate of resident registration,
            Driver’s license, Passport, etc.)
          </p>
          <div class="id-card">
            <vs-input
              placeholder="Image Upload"
              class="input-block input-custom"
              disabled
              :value="files.idCard.name"
            ></vs-input>
            <input
              type="file"
              name="idCard"
              ref="idCardImg"
              style="display:none"
              @change="setFile"
            />
            <vs-button class="btn-agree-view" @click="$refs.idCardImg.click()"
              >Find files</vs-button
            >
          </div>
          <ul class="bill-help">
            <li class="bill">
              Please indicate the submission date on the ID card by your
              handwriting.
            </li>
          </ul>
        </li>
        <!-- //신분증 사진 -->

        <!-- 신분증 들고 있는 사진 -->
        <li class="li">
          <p>2. Photo of yourself holding your ID card</p>
          <div class="id-card">
            <vs-input
              placeholder="Image Upload"
              class="input-block input-custom"
              disabled
              :value="files.withId.name"
            ></vs-input>
            <input
              type="file"
              name="withId"
              ref="withIdImg"
              style="display:none"
              @change="setFile"
            />
            <vs-button class="btn-agree-view" @click="$refs.withIdImg.click()"
              >Find files</vs-button
            >
          </div>
          <ul class="bill-help">
            <li class="bill">
              Please indicate the submission date on the ID card by your
              handwriting.
            </li>
            <li class="bill">
              The submission date on the ID card should match the date on the
              photographed ID card under 1. Above
            </li>
          </ul>
        </li>
        <!-- //신분증 들고 있는 사진 -->
      </ul>
      <div class="btn-bottom-area">
        <vs-button @click="residenceCancel">Cancel</vs-button>
        <vs-button @click.prevent="requestResidence">Confirm</vs-button>
      </div>
    </div>
    <!-- LOGIN FORM//E -->
    <vs-popup
      fullscreen
      :active.sync="popupActive"
      class="full-popup residence"
    >
      <div class="fullscreen-wrapper">
        <h1>Identity verification</h1>
        <p>Please upload your picture for following requirement.</p>
        <div class="help">※ Less than 10MB / Attach JPG image file only</div>
      </div>
      <div class="btn-bottom-area">
        <vs-button @click="residenceCancel">Cancel</vs-button>
        <vs-button @click.prevent="requestResidence">Confirm</vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import Api from "@/common/Api";
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      popupActive: false,
      files: {
        idCard: {},
        withId: {},
        address: {},
      },
    };
  },
  computed: {
    ...mapState(["Server"]),
  },
  methods: {
    setFile($event) {
      const { name, files } = $event.target;
      if (!files.length) {
        return false;
      }
      // size 체크
      const fileMaxSize = 10485760;
      if (
        files[0].size > fileMaxSize ||
        !/\.(jpg|jpeg|png)$/i.test(files[0].name)
      ) {
        this.$vs.notify({
          text: "You can upload Less than 10MB / Attach JPG image file only.",
          type: "warning",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      this.files[name] = files[0];
    },
    requestResidence() {
      // if(!this.uploadModalScrollEnd) {
      //   return false;
      // }
      // 세 파일 다 업로드 되었는지 판단
      if (_.some(this.files, (f) => !(f instanceof File))) {
        this.$vs.notify({
          title: "Identify verification error",
          text: "Please upload all of pictures.",
          type: "warning",
          position: "top-left",
        });
        return false;
      }

      this.$vs.loading();

      Api.User.RequestKYCAuth({
        upfile1: this.files.idCard,
        upfile2: this.files.withId,
        // upfile3: this.files.address,
      })
        .then((response) => {
          this.$vs.notify({
            title: "Identify verification",
            text: "Identify verification complete.",
            type: "warning",
            position: "top-left",
          });
          this.popupActive = false;
          this.residenceCancel();
          setTimeout(() => {
            this.$router.go(-1);
          }, 50);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    residenceCancel() {
      this.files = {
        idCard: {},
        withId: {},
        address: {},
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.vs-component.vs-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}
</style>
